import {GeneralAction, UserPayload} from '../../../@types/actions';
import {EXTRA_INITIALIZE} from '../../../constants/ExtraConstants';

export const GetInitAction = (userId: string): GeneralAction<UserPayload> => ({
    type: EXTRA_INITIALIZE,
    payload: {userId}
});
